// extracted by mini-css-extract-plugin
export default {"wrapper":"EnvironmentOptions_wrapper__IgHjI"};